module.exports = __webpack_public_path__ + "img/MaeveKnows.fe931379.jpeg";